import { withMediaProps } from "react-media-player";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { Box, Flex, Slider, SliderTrack, SliderFilledTrack, SliderThumb } from "@chakra-ui/react";
import { IndicatorIcon } from "components/icons";
import { MediaProps } from "./CustomMediaSlider";
import PodcastColorTypes from "types/podcastColorTypes";

interface VolumeSliderProps {
  media?: MediaProps;
  volumeSliderHeight?: string;
}

function VolumeSlider({ media, volumeSliderHeight }: VolumeSliderProps) {
  const changeRange = (e: number) => {
    if (media) media.setVolume(e / 100);
  };

  const sliderOrientation = volumeSliderHeight ? "vertical" : "horizontal";
  const sliderHeight = volumeSliderHeight ?? "0";

  return (
    <Flex width="100%" flexDir="column">
      <Slider aria-label="slider-ex-4" width="100%" borderWidth="0px" default={100} max={100} onChange={changeRange} orientation={sliderOrientation} minH={sliderHeight}>
        <SliderTrack padding="0" height="8px" bg={getPodcastThemeToken(PodcastColorTypes.VolumeTrack)} borderRadius="16px" borderWidth="0px" borderColor="transparent">
          <SliderFilledTrack bg={getPodcastThemeToken(PodcastColorTypes.VolumeFilledTrack)} />
        </SliderTrack>
        <SliderThumb
          width="18px"
          bg="gray.150"
          height="18px"
          border={`2px solid ${getPodcastThemeToken(PodcastColorTypes.VolumeFilledTrack)}`}
          borderColor={getPodcastThemeToken(PodcastColorTypes.VolumeFilledTrack)}
        >
          <Box color="purple.50" height="5px" as={IndicatorIcon} />
        </SliderThumb>
      </Slider>
    </Flex>
  );
}

export const CustomVolumeSlider = withMediaProps(VolumeSlider);
